export { default as PostViewer } from './component';
